import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { icon } from './data/icon';
import BaseIcon from './icon-list/base-icon';
import RectIcon from './icon-list/rect-icon';
import AudioIcon from './icon-list/audio-icon';
import { assert } from '../lib/utils';

import setting from '../../setting';

const css = require('./icon-list.css').default;

const tag = '-通行腔.mp3';

export default function ({ page, accent, style, onSelect }: {
    page: string,
    accent: string,
    style?: React.CSSProperties,
    onSelect: (e: React.MouseEvent, command: string) => void,
}) {
    const [icons, setIcons] = useState<icon[]>([]);
    const [playing, setPlaying] = useState<string | null>(null);
    const main = useRef<HTMLDivElement>(null);

    useEffect(() => {
        fetch(settingFile(page))
        .then(async res => {
            if (res.status === 200) {
                const icons = await res.json();
                assert(icons instanceof Array && icons.every((i): i is icon => icon.isa(i)), '');
                setIcons(icons);
            } else {
                setIcons([]);
            }
        });
    }, [page]);

    return (
    <div ref={main} id={css.container} style={style}>
        {(() => {
            return icons
            .map(icon => icon.command)
            .filter((command): command is string => typeof command === 'string')
            .filter(isMp3)
            .map(mp3 => {
                const src = mp3.endsWith(tag) ? mp3.slice(0, -1 * tag.length) + `-${accent}.mp3` : mp3;
                return <audio
                    src={`${setting.bookDir}/補充資料/${src}`}
                    data-src={`${setting.bookDir}/補充資料/${mp3}`}
                    onPlay={e => setPlaying(mp3)}
                    onPause={e => setPlaying(null)}
                />
            });
        })()}
        {(() => {
            return icons
            .filter(icon.isBaseIcon)
            .map(icon => {
                if (typeof icon.command === 'string' && isMp3(icon.command) && icon.icon === null) {
                    return (
                    <AudioIcon icon={icon} playing={playing === icon.command} onSelect={(url, action) => {
                        assert(main.current !== null, '');
                        if (action === 'play') {
                            play(main.current, url);
                        } else if (action === 'pause') {
                            main.current.querySelectorAll('audio').forEach(i => {
                                i.pause();
                            });
                        } else {
                            main.current.querySelectorAll('audio').forEach(i => {
                                i.pause();
                                i.currentTime = 0;
                            });
                        }
                    }}/>);
                } else {
                    return <BaseIcon icon={icon} onSelect={(e, command) => {
                        if (isMp3(command)) {
                            assert(main.current !== null, '');
                            play(main.current, command);
                        } else {
                            onSelect(e, command);
                        }
                    }}/>;
                }
            });
        })()}
        {(() => {
            return icons
            .filter(icon.isRect)
            .map(icon => <RectIcon icon={icon} onSelect={(e, url) => {
                if (isMp3(url)) {
                    assert(main.current !== null, '');
                    play(main.current, url);
                } else {
                    onSelect(e, url);
                }
            }}/>);
        })()}
    </div>);

    function play(main: HTMLDivElement, url: string) {
        main.querySelectorAll('audio')
        .forEach(i => {
            if (i.getAttribute('data-src') === `${setting.bookDir}/補充資料/${url}`) {
                i.play();
            } else {
                i.pause();
                i.currentTime = 0;
            }
        });
    }
}

function isMp3(src: string) {
    return src.toLowerCase().endsWith('.mp3');
}

function settingFile(page: string) {
    // page could be '04,05/index.dom.html' or '06,07.jpg'
    const level1 = page.split('/')[0];      // '04,05' or '06,07.jpg'
    const name = level1.replace(/\..*/, '');   // '04,05' or '06,07'
    return `${setting.bookDir}/pages/${name}.json`;
}
